import app from 'flarum/common/app';

app.initializers.add('bigge-discussion-preview-common', () => {
  //
});
